function openLinkedQuestion() {
  if (!window.location.hash) return;
  let id;
  try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
  const target = document.getElementById(id);
  if (target instanceof HTMLDetailsElement && target.closest('.bruler-faq')) {
    target.open = true;
    target.scrollIntoView({ block: 'start' });
  }
}
openLinkedQuestion();
window.addEventListener('hashchange', openLinkedQuestion);
document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a') : null;
  if (!link || !window.location.pathname.startsWith('/pages/plumbing-questions-answered')) return;
  let channel;
  if (link.href.startsWith('tel:')) channel = 'phone';
  else if (link.hostname === 'wa.me') channel = 'whatsapp';
  else if (link.pathname === '/pages/contact') channel = 'contact_page';
  else if (link.pathname.startsWith('/products/')) channel = 'service_page';
  if (!channel) return;
  const parameters = { channel, link_path: link.pathname };
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'faq_link_click', parameters);
  } else if (window.Shopify?.analytics?.publish) {
    window.Shopify.analytics.publish('faq_link_click', parameters);
  }
});
